// tslint:disable
export var NoteTypeCategory;
(function (NoteTypeCategory) {
    // NOTE
    NoteTypeCategory[NoteTypeCategory["NOTE"] = 1] = "NOTE";
    // TASK
    NoteTypeCategory[NoteTypeCategory["TASK"] = 2] = "TASK";
    // EVENT
    NoteTypeCategory[NoteTypeCategory["EVENT"] = 3] = "EVENT";
    // NDEF
    NoteTypeCategory[NoteTypeCategory["DefaultNoteType"] = 4] = "DefaultNoteType";
})(NoteTypeCategory || (NoteTypeCategory = {}));
NoteTypeCategory['DEFAULTNOTETYPE'] = 4;
//# sourceMappingURL=NoteTypeCategory.js.map